import { render } from "./ViewUsager.vue?vue&type=template&id=01cb2ed4&ts=true"
import script from "./ViewUsager.vue?vue&type=script&lang=ts"
export * from "./ViewUsager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__